const customer = {
    name: '',

    emails: {
        pods: '',
        corrosion: ''
    }
}

export default customer;